import React from 'react';

type ExcelFileIconProps = {
  width?: string;
  height?: string;
  color?: string;
};

function ExcelFileIcon({
  width = '50',
  height = '66',
  color,
}: ExcelFileIconProps) {
  return (
    <svg
      width={width}
      height={height}
      color={color}
      viewBox='0 0 50 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M50 22H0V44H50V22Z' fill='#229C5B' />
      <path
        d='M50 44H0V58C0 62.4183 3.58172 66 8 66H42C46.4183 66 50 62.4183 50 58V44Z'
        fill='#275A3F'
      />
      <path
        d='M42 0H8C3.58172 0 0 3.58172 0 8V22H50V8C50 3.58172 46.4183 0 42 0Z'
        fill='#2FB776'
      />
      <path
        d='M37 20.1875H15.125C13.3991 20.1875 12 21.5866 12 23.3125V45.1875C12 46.9134 13.3991 48.3125 15.125 48.3125H37C38.7259 48.3125 40.125 46.9134 40.125 45.1875V23.3125C40.125 21.5866 38.7259 20.1875 37 20.1875Z'
        fill='black'
        fillOpacity='0.51'
      />
      <path
        d='M34 17H12.125C10.3991 17 9 18.3991 9 20.125V42C9 43.7259 10.3991 45.125 12.125 45.125H34C35.7259 45.125 37.125 43.7259 37.125 42V20.125C37.125 18.3991 35.7259 17 34 17Z'
        fill='#185F33'
      />
      <path
        d='M29.3125 38.875L24.9095 30.9062L29.1192 23.25H25.6828L23.084 28.1384L20.5281 23.25H16.9843L21.2154 30.9062L16.8125 38.875H20.2489L23.0195 33.6964L25.7688 38.875H29.3125Z'
        fill='white'
      />
    </svg>
  );
}

export default ExcelFileIcon;
